// 描述： 造价文件接口
// 时间： 2020 / 6 / 23
// created by zjj
import request from '../request.js'


//查询工种列表  李开明
const selectProfessions = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/selectProfessions',
    })
}

//分析模块-地区内分析（人工）-当前价格  李开明
const currentPriceInRegion = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/currentPriceInRegion',
    })
}

//分析模块-地区内分析（人工）-环比涨跌幅和同比涨跌幅  李开明
const professionUpAndDownInRegion = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/professionUpAndDownInRegion',
    })
}

//分析模块-地区内分析（人工）-价格走势-价格  李开明
const priceTrend = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/priceTrend',
    })
}

//分析模块-地区内分析（人工）-价格走势-幅度  李开明
const rangeTrend = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/rangeTrend',
    })
}

//查询省的地级市列表  李开明
const selectCitys = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/selectCitys',
    })
}

//分析模块-地区间分析（人工）-价格对比-价格 李开明
const priceComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/priceComparison',
    })
}

//分析模块-地区间分析（人工）-价格对比-幅度 李开明
const rangeComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/rangeComparison',
    })
}

//分析模块-地区间分析（人工）-走势对比-价格 李开明
const priceTrendComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/priceTrendComparison',
    })
}

//分析模块-地区间分析（人工）-走势对比-幅度 李开明
const rangeTrendComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/rangeTrendComparison',
    })
}

//分析模块-地区内分析（材料）-环比涨跌幅和同比涨跌幅 李开明
const regionMaterialUpAndDown = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/regionMaterialUpAndDown',
    })
}

//分析模块-地区内分析（材料）-价格走势-价格 李开明
const materialPriceTrend = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/materialPriceTrend',
    })
}

//分析模块-地区内分析（材料）-价格走势-幅度 李开明
const materialRangeTrend = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/materialRangeTrend',
    })
}

//分析模块-地区间分析（材料）-价格对比-价格 李开明
const materialPriceComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/materialPriceComparison',
    })
}

//分析模块-地区间分析（材料）-价格对比-幅度 李开明
const materialRangeComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/materialRangeComparison',
    })
}

//分析模块-地区间分析（材料）-走势对比-价格 李开明
const materialPriceTrendComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/materialPriceTrendComparison',
    })
}

//分析模块-地区间分析（材料）-走势对比-幅度 李开明
const materialRangeTrendComparison = function (params) {
    return request({
        method: 'post',
        data: params,
        url: 'resourcesPriceAh/materialRangeTrendComparison',
    })
}

//查询不同人员的主要材料列表 
const getMainMaterials = function (params) {
    return request({
        method: 'post',
        data: params,
        url: '/resourcesForUsers/getMainMaterials',
    })
}

export {
    selectProfessions,
    currentPriceInRegion,
    professionUpAndDownInRegion,
    priceTrend,
    rangeTrend,
    selectCitys,
    priceComparison,
    rangeComparison,
    priceTrendComparison,
    rangeTrendComparison,
    regionMaterialUpAndDown,
    materialPriceTrend,
    materialRangeTrend,
    materialPriceComparison,
    materialRangeComparison,
    materialPriceTrendComparison,
    materialRangeTrendComparison,
    getMainMaterials
}